import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "../store";
import { Auth } from "aws-amplify";

// import beforeEach from "./beforeEach";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});

router.beforeResolve((to, from, next) => {
  const cameFromInsideApp = Boolean(sessionStorage.logout);
  const isNavigating = Boolean(sessionStorage.isNavigating);

  if (from.path.includes("/extensions/") && from.path.split("/").length === 4 && !cameFromInsideApp && !isNavigating) {
    sessionStorage.tempParams = JSON.stringify({
      ...from.params,
      type: "extension",
    });
  }
  // console.log({ to, from });
  if (to.name === "Join contest") {
    sessionStorage.tempParams = JSON.stringify({
      ...to.params,
      type: "Join contest",
    });
  }
  // if (
  //   to.name === "Detalhes da extensão" &&
  //   ["rhodium", "traderbot"].includes(to.params.partner_name)
  // ) {
  //   sessionStorage.tempParams = JSON.stringify({
  //     ...to.params,
  //     type: "Detalhes da extensão",
  //   });
  // }
  if (to.name === "Detalhes da extensão") {
    sessionStorage.tempParams = JSON.stringify({
      ...to.params,
      type: "Detalhes da extensão",
    });
  }

  delete sessionStorage.logout;
  const query = { ...to.query };
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    Vue.prototype.loading = true;
    let valid_email = sessionStorage.getItem("bypassCache");
    let result = valid_email ? true : false;

    Auth.currentAuthenticatedUser({ bypassCache: result })
      .then((data) => {
        if (data && data.signInUserSession) {
          // console.log("DATA", data);
          if (!data.attributes.email_verified) {
            Auth.verifyCurrentUserAttribute("email").then(() => {});
            router.push({
              path: "email-validate",
              query: { ...query },
            });
          } else {
            store.dispatch("accountTypes/getAuth", true);
            sessionStorage.removeItem("bypassCache");
            if (sessionStorage.tempParams) {
              let parsedParams = JSON.parse(sessionStorage.tempParams);
              delete sessionStorage.tempParams;
              switch (parsedParams.type) {
                case "extension":
                  next({
                    name: "Detalhes da extensão",
                    params: parsedParams,
                  });
                  break;
                case "Join contest":
                  next({
                    name: "Join contest",
                    params: parsedParams,
                  });
                case "Detalhes da extensão":
                  next({
                    name: "Detalhes da extensão",
                    params: parsedParams,
                  });
                default:
                  break;
              }
            } else {
              const queryTypes = {
                plans: () => {
                  next({ name: "Pagamentos", query: { ...query } });
                },
              };

              query.type && query.type[query.type] ? queryTypes[query.type]() : next();
            }
          }
        }
      })
      .catch((e) => {
        // console.log("catch route", e);
        store.dispatch("accountTypes/getAuth", false);

        next({
          path: "/auth",
          query: {
            ...to.query,
          },
        });
      });
  }
  next({ query: { ...query } });
  delete sessionStorage.isNavigating;
});

// router.beforeEach((to, from, next) => {
//   Vue.prototype.loading = true;

//   next();
// });
router.afterEach((to, from, next) => {
  Vue.prototype.loading = false;
});

const routerPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
export default router;
